import { normalizePathname } from 'utils';
import { GLOBALS } from 'constants/app/global-variables';
import { ROUTE_RESERVED_ALIASES } from 'constants/app/route-reserved-words';

/*
 * implementation is done this way, because effects are being called after
 * children are mounted and their effects are called
 */
export const useDefineInitialMountingPath = (): void => {
  const defineInitialMountingPath = () => {
    const path = window.location.pathname;
    const detectReservedAliasRegex = new RegExp(
      `/(${ROUTE_RESERVED_ALIASES.join('|')})${
        path.endsWith('/') ? '/' : ''
      }.*$`
    );
    const correctPath = path.replace(detectReservedAliasRegex, '/');
    const normalizedPath = normalizePathname(correctPath);
    GLOBALS.navigation.initialMountingPath = normalizedPath;
    GLOBALS.navigation.isAlreadySetInitialMountingPath = true;
  };

  !GLOBALS.navigation.isAlreadySetInitialMountingPath &&
    defineInitialMountingPath();
};
